export const phoneTypeMap = [
  {
    type: 'Mobile',
    field: 'mobilePhone',
  },
  {
    type: 'Work',
    field: 'workPhone',
  },
  {
    type: 'Home',
    field: 'homePhone',
  },
];

export default { phoneTypeMap };